import { FormProvider } from 'react-hook-form';
import { MdClear } from 'react-icons/md';
import { routes } from '~/utils/routes';
import { Color } from '~/utils/styles/enums';
import noImage from '@app/_assets/no-image.png';
import { css } from '@styled-system/css';
import { Center, HStack, Image, Paragraph, VStack } from '@styled-system/jsx';
import { CommentInputArea } from './comment-input-area';
import { SendButton } from './send-button';
import type { PostCommentContainerProps } from './type';
import { useLocalState } from './use-local-state';

export const PostCommentContainer = (props: PostCommentContainerProps) => {
  const { isLogin, tellerUser, canAddComment, form, onSubmit } =
    useLocalState(props);
  const { onDeselectParentComment, replyComment, storyId } = props;
  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className={css({ w: '100%' })}
      >
        <VStack w="100%" alignItems="flex-start">
          {replyComment && (
            <HStack w="100%">
              <Image
                src={replyComment.user.thumbnailUrl ?? noImage}
                alt={replyComment.user.name}
                w="24px"
                h="24px"
                borderRadius="50%"
                flexShrink="0"
                mb="3px"
              />
              <VStack
                alignItems="flex-start"
                w="100%"
                overflow="hidden"
                gap="1"
              >
                <Paragraph
                  fontWeight="bold"
                  fontSize="size_11"
                  color="accent.1000"
                  lineHeight="1"
                  w="100%"
                >
                  {replyComment.user.name}
                </Paragraph>
                <Paragraph
                  fontSize="size_10"
                  color="accent.700"
                  lineHeight="1"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  overflow="hidden"
                  w="100%"
                >
                  {replyComment.text?.body}
                </Paragraph>
              </VStack>

              <Center
                cursor="pointer"
                flexShrink="0"
                h="100%"
                onClick={() => {
                  onDeselectParentComment?.();
                }}
              >
                <MdClear color={Color.ACCENT_700} size={16} aria-label="解除" />
              </Center>
            </HStack>
          )}
          {canAddComment === false ? (
            <Paragraph color="accent.500" fontSize="sm">
              このストーリーへのコメントは制限されています
            </Paragraph>
          ) : (
            <HStack w="100%" alignItems="flex-end">
              <input type="hidden" {...form.register('replyCommentId')} />
              <CommentInputArea
                requireLogin={!isLogin}
                loginPagePath={routes.login.url(`/s/${storyId}/comments`)}
                user={tellerUser}
                placeholder={
                  replyComment
                    ? `@${replyComment?.user.name} への返信`
                    : 'コメントを入力'
                }
                onCommandEnterSubmit={form.handleSubmit(onSubmit)}
              />

              <SendButton />
            </HStack>
          )}
        </VStack>
      </form>
    </FormProvider>
  );
};
